module.exports = __webpack_public_path__ + "img/survey_monkey.ff94c5e9.svg";